import axios from 'axios';
import moment from 'moment-timezone';
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import BootstrapVue from 'bootstrap-vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import en from 'vee-validate/dist/locale/en';
import ja from 'vee-validate/dist/locale/ja';
import VeeValidate from 'vee-validate';
import SlimDialog from 'v-slim-dialog';
import VueYouTubeEmbed from 'vue-youtube-embed';
import ValidateLaravel from './helpers/validate-laravel';
import jaAttributes from './lang/ja/validation-attributes';
import enAttributes from './lang/en/validation-attributes';
import 'v-slim-dialog/dist/v-slim-dialog.css';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import App from './App.vue';
import Request from './utilities/Request';
import router from './router';
import i18n from './lang/index';

Vue.config.productionTip = false;

Vue.use(VueYouTubeEmbed);
Vue.use(SlimDialog);
Vue.use(Loading);
Vue.use(BootstrapVue);
Vue.use(VueAwesomeSwiper);
Vue.use(ValidateLaravel);
Vue.use(VeeValidate, {
  i18n,
  dictionary: {
    en: {
      messages: en.messages,
      attributes: enAttributes,
    },
    ja: {
      messages: ja.messages,
      attributes: jaAttributes,
    },
  },
});

window.axios = axios;
window.Request = Request;

moment.tz.setDefault('Asia/Tokyo');
window.moment = moment;

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
